import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  FilterDataPayload,
  OrderConfiguration, OrderData,
  OrderModel, OrderPayload
} from '../model/order.model';
import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { API_URL } from '../config/general.config';
import { OrderType } from '../config/order.config';
import { UserModel } from '../model/general.model';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  private getOrderApi(): string {
    return `${API_URL}/orders`;
  }

  private dataApi(): string {
    return `${API_URL}/data`;
  }

  private dataApiWithProjectId(projectId: string): string {
    return `${this.dataApi()}/${projectId}`
  }


  constructor(
    private _http: HttpClient,
  ) { }


  getOrderConfig(projectUuid: string): Observable<OrderConfiguration> {
    return this._http.get<OrderConfiguration>(this.getOrderApi() + '/configuration/' + projectUuid);
  }

  getOrderById(id: number): Observable<OrderModel> {
    return this._http.get<OrderModel>(`${this.getOrderApi()}/${id}`)
  }

  getDataByFilters(config: FilterDataPayload): Observable<OrderData> {
    return this._http.post<OrderData>(this.dataApi(), config)
  }

  getFilterValues(projectUuid: string, header: string, dataType: OrderType): Observable<string[]> {
    return this._http.get<string[]>(`${this.dataApiWithProjectId(projectUuid)}/values`, {
      params: {
        header,
        dataType
      }
    });
  }

  getDataFilters(projectId: string, dataType: OrderType): Observable<string[]> {
    return this._http.get<string[]>(`${this.dataApiWithProjectId(projectId)}/headers`, {
      params: {
        dataType
      }
    }).pipe(
      map((response) => response.sort((a, b) => a.localeCompare(b)))
    );
  }

  saveOrder(payload: OrderPayload): Observable<OrderModel> {
    return this._http.post<OrderModel>(this.getOrderApi(), payload)
  }

  updateOrder(orderId: number, payload: OrderPayload): Observable<OrderModel> {
    return this._http.put<OrderModel>(`${this.getOrderApi()}/${orderId}`, payload);
  }

  runOrder(orderId: number): Observable<void> {
    return this._http.put<void>(`${this.getOrderApi()}/${orderId}/execute`, {})
  }

  downloadZip(orderId: number): Observable<HttpEvent<Blob>> {
    const req = new HttpRequest('GET', `${this.getOrderApi()}/${orderId}/attachments/zip`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/octet-stream',
        'Accept': 'application/octet-stream',
        'ngsw-bypass': ''
      }),
      responseType: 'blob',
      reportProgress: true
    });

    return this._http.request(req);
  }
  cancelOrder(orderId: number): Observable<void> {
    return this._http.post<void>(`${this.getOrderApi()}/${orderId}/cancel`, {})
  }

  getConfigUsers(projectId: string): Observable<UserModel[]> {
    return this._http.get<UserModel[]>(this.getOrderApi() + '/configuration/' + projectId + '/users');
  }

  assignExtraUsers(userIds: string[], orderId: number): Observable<void> {
    return this._http.put<void>(`${this.getOrderApi()}/${orderId}/users`, userIds)
  }

  close(orderId: number): Observable<OrderModel> {
    return this._http.post<OrderModel>(`${this.getOrderApi()}/${orderId}/close`, {})
  }

  searchMisingSKMS(id: number): Observable<void> {
    return this._http.post<void>(`${this.getOrderApi()}/${id}/pse-fanout`, {})
  }
}
